import VeeValidate from 'vee-validate';
import { Validator } from 'vee-validate';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import PhoneNumber from 'awesome-phonenumber';
import Toasted from 'vue-toasted';
import { Utils } from '@/Utils';
import { AppConstants } from '@/app.constants';
import axios from 'axios';
import VModal from 'vue-js-modal';
import { store, decodeToken } from '@/store';
import Autocomplete from '@trevoreyre/autocomplete-vue'
import '@trevoreyre/autocomplete-vue/dist/style.css'

import { LicenseManager } from '@ag-grid-enterprise/core';

LicenseManager.setLicenseKey(
    'ThirtyTech_MultiApp_1Devs23_September_2020__MTYwMDgxNTYwMDAwMA==952595342e2c123a4d1f36dd8dea7203'
);

require('ladda/dist/ladda.min.css');
import '@/assets/css/tailwind.css';

const search = location.search;
if (search.indexOf('token')) {
    const query = Utils.fromQueryString(location.search.substring(1));
    if (query['token']) {
        localStorage.setItem(AppConstants.LocalStorageKeys.jwt, query['token']);
        store.jwt = query['token'];
        store.isAuthenticated = true;
        store.token = decodeToken(query['token']);
        history.replaceState({}, '', window.location.href.split('?')[0]);
    }
}

let token;

try {
    token = localStorage.getItem(AppConstants.LocalStorageKeys.jwt);
} catch (e) {}

// set default axios headers
if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

axios.interceptors.response.use(
    res => res,
    err => {
        if (err.response.status === 401) {
            localStorage.removeItem(AppConstants.LocalStorageKeys.jwt);
            window.location.reload();
        }

        return Promise.reject(err);
    }
);

const phoneNumber = {
    getMessage: field => `Please enter a valid phone number`,
    validate(value) {
        return new Promise(resolve => {
            let phone = new PhoneNumber('+1' + value);
            resolve({ valid: phone.isValid() });
        });
    },
};
Validator.extend('phoneNumber', phoneNumber as any);

Validator.extend('objectNotEmpty', {
    validate: (value) => (Object.keys(value).length > 0)
  });

Vue.config.productionTip = false;
Vue.use(VeeValidate);
Vue.use(Toasted);
Vue.use(VModal);
Vue.use(Autocomplete)

new Vue({
    router,
    render: h => h(App),
}).$mount('#app');
